import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { dbrVersionListData } from "service/service";
import CustomAnalysisTableBase from './CustomAnalysisTableBase';

const columnMapping: Record<string, string> = {
  workspace_name: "Workspace Name",
  cluster_name: "Cluster Name",
  dbr_version: "DBR Version",
  compute_type: "Compute Type",
  date: "Date",
};

const defaultColumns = Object.values(columnMapping);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DBRVersionListTablePage: React.FC = () => {
  const query = useQuery();

  const version = query.get("version") || "";
  const versionOnly = version.split("•")[0].trim();
  const computeType = query.get("compute_type") || "";

  const filterTableDataFn = useCallback((data: any[] = []): any[] =>
    data.map((row) => {
      const filtered: any = {};
      for (const key of Object.keys(columnMapping)) {
        if (key === "date" && row[key]) {
          filtered[key] = new Date(row[key]).toLocaleDateString();
        } else if (key === "cluster_count" && typeof row[key] === "number") {
          filtered[key] = row[key].toLocaleString();
        } else {
          filtered[key] = row[key];
        }
      }
      return filtered;
    }), []);

  const getTableTitle = () => {
    let title = `DBR Version List - ${version}`;
    if (computeType) {
      const type = computeType.toLowerCase() === 'interactive' ? 'Interactive' : 'Job';
      title += ` - ${type}`;
    }
    return title;
  };

  return (
    <CustomAnalysisTableBase
      fetchService={dbrVersionListData}
      columnMapping={columnMapping}
      defaultColumns={defaultColumns}
      filterTableDataFn={filterTableDataFn}
      breadcrumbLabel="DBR Runtime Versions"
      tableTitle={getTableTitle}
      tableType="dbr-version-list"
      extraParams={{ versionOnly, computeType }}
      preserveFilterKey="dbr_version_filters"
      isAutoWidth={true}
    />
  );
};

export default DBRVersionListTablePage;
